import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllCoverage = (page,currentRowsPerPage, filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getAllCoverage(page,currentRowsPerPage, filter).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETCOVERAGESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCOVERAGEFAILED,
                payload: 'err', 
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCOVERAGEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getCoverageById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getCoverageById(id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            
            dispatch({
                type: ActionTypes.GETCOVERAGEBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCOVERAGEBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCOVERAGEBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveCoverage = (data) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.saveCoverage(data).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVECOVERAGESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVECOVERAGEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.SAVECOVERAGEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateCoverage = (data, id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateCoverage(data, id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATECOVERAGESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATECOVERAGEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.UPDATECOVERAGEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleCoverage = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleCoverage(id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLECOVERAGESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLECOVERAGEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLECOVERAGEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}